import { Helmet } from 'react-helmet-async';

const AboutPageHelmet = () => {
  return (
    <Helmet>
      {/* Title & Meta */}
      <title>About Us - Velocent Global Secure Logistics</title>
      <meta
        name='description'
        content='Learn more about Velocent Global, a trusted secure logistics company specializing in transporting gold, cash, artwork, and other high-value assets. Discover our mission, values, and commitment to safety and discretion.'
      />
      <meta
        name='keywords'
        content='About Velocent Global, secure logistics company, valuables transportation, gold logistics, cash in transit, artwork transport, company mission, trusted logistics partner'
      />

      {/* Open Graph */}
      <meta property='og:type' content='website' />
      <meta
        property='og:url'
        content='https://www.velocentglobal.com/about-us'
      />
      <meta
        property='og:title'
        content='About Velocent Global - Secure Logistics Experts'
      />
      <meta
        property='og:description'
        content='Velocent Global provides trusted and secure logistics for gold, cash, artworks, and other high-value items. Learn about our expertise, mission, and dedication to safeguarding valuables.'
      />
      <meta
        property='og:image'
        content='https://www.velocentglobal.com/assets/images/favicon.png'
      />
      <meta property='og:site_name' content='Velocent Global' />
      <meta property='og:locale' content='en_US' />

      {/* Canonical */}
      <link rel='canonical' href='https://www.velocentglobal.com/about-us' />
    </Helmet>
  );
};

export default AboutPageHelmet;
